export default {
	namespaced: true,

	state: {
		bxajaxid: null,
		remote: null,
		link: null,
		items: [],
		loading: false
	},

	getters: {
		items(state) {
			return state.items;
		},

		compareEmpty(state) {
			return !state.items || !state.items.length;
		},

		compareCount(state) {
			return state.items ? state.items.length : 0;
		},

		compareCountByItem(state) {
			return (id) => {
				let result = state.items.find(item => item.id === id);
				return result ? result.count : 0;
			};
		}
	},

	mutations: {
		set(state, data) {
			state.bxajaxid = data.bxajaxid;
			state.remote = data.remote;
			state.link = data.link;

			if (Array.isArray(data.items)) {
				const map = new Map();
				for (const item of [...state.items, ...data.items]) {
					map.set(item.id, item);
				}
				state.items = Array.from(map.values());
			}
		},

		setLoading(state, value) {
			state.loading = value;
		},

		removeItem(state, id) {
			const index = state.items.findIndex(item => +item.id === +id);
			if (index !== -1) {
				state.items.splice(index, 1);
			}
		},

		addItem(state, id) {
			const exists = state.items.some(existingItem => +existingItem.id === +id);
			if (!exists) {
				state.items.push(id);
			}
		}
	},

	actions: {
		async request(context, options) {
			context.commit('setLoading', true);

			let formattedData = new FormData();

			if (options instanceof FormData) {
				formattedData = options;
			} else {
				let makeFormData = (data, parentKey) => {
					if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
						Object.keys(data).forEach((key) => {
							makeFormData(data[key], parentKey ? `${parentKey}[${key}]` : key);
						});
					} else {
						formattedData.append(parentKey, data == null ? '' : data);
					}
				};

				makeFormData(options);
			}
			if (context.state.bxajaxid) {
				formattedData.set('bxajaxid', context.state.bxajaxid);
			}

			const response = await fetch(context.state.remote, {
				method: 'POST',
				body: formattedData
			});

			if (!response.ok) {
				console.warn('[vuex] compare: AJAX request failed', response);
			} else {
				const data = await response.json();
				console.log('[vuex] compare: loaded', data);
				context.commit('set', data);
			}

			context.commit('setLoading', false);
		},

		async add(context, ids) {
			const state = context.state

			const existingIds = new Set(state.items.map(item => item.id));
			const uniqueToAdd = ids.filter(id => !existingIds.has(id));
			if (!uniqueToAdd.length) return;
			const items = [...existingIds, ...uniqueToAdd];

			await context.dispatch('request', {
				action: 'add',
				items: Array.from(new Set(items))
			});
		},

		async remove(context, ids) {
			const state = context.state

			const removeSet = new Set(ids.map(id => +id));

			const itemsToRemove = state.items
				.filter(item => removeSet.has(+item.id))
				.map(item => item.id);

			await context.dispatch('request', {
				action: 'remove',
				items: itemsToRemove
			});
		}
	}
};